import { render, staticRenderFns } from "./list-item.component.vue?vue&type=template&id=238d2f74&scoped=true"
import script from "./list-item.component.vue?vue&type=script&lang=js"
export * from "./list-item.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d2f74",
  null
  
)

export default component.exports